/* card/reducer */
import { createReducer } from "typesafe-actions";
import { CardTypeActionTypes, CardTypeState } from "./types";
import {
  fetchRequest,
  fetchSuccess,
  fetchError,
  saveRequest,
  saveSuccess,
  saveError,
} from "./actions";

export const initialState: CardTypeState = {
  data: undefined,
  errors: undefined,
  loading: false
};

type ActionType =
  | ReturnType<typeof fetchRequest>
  | ReturnType<typeof fetchSuccess>
  | ReturnType<typeof fetchError>
  | ReturnType<typeof saveRequest>
  | ReturnType<typeof saveSuccess>
  | ReturnType<typeof saveError>;

export default createReducer<CardTypeState, ActionType>(initialState)
  .handleType(CardTypeActionTypes.FETCH, (state) => {
    return { ...state, loading: true, data: undefined, errors: undefined };
  })
  .handleType(CardTypeActionTypes.FETCH_SUCCESS, (state, action) => {
    return {
      ...state,
      loading: false,
      data: action.payload,
      errors: undefined,
    };
  })
  .handleType(CardTypeActionTypes.FETCH_ERROR, (state, action) => {
    return {
      ...state,
      loading: false,
      data: undefined,
      errors: action.payload,
    };
  })
  .handleType(CardTypeActionTypes.SAVE_REQUEST, (state) => {
    return { ...state, loading: true, errors: undefined };
  })
  .handleType(CardTypeActionTypes.SAVE_SUCCESS, (state, action) => {
    return {
      ...state,
      loading: false,
      data: action.payload,
      errors: undefined,
    };
  })
  .handleType(CardTypeActionTypes.SAVE_ERROR, (state, action) => {
    let oldState: any = {...state};
    return {
      ...state,
      loading: false,
      errors: action.payload,
      data: oldState.data
    };
  });
